import {createSlice} from "@reduxjs/toolkit"

export const reOzsFormReducer = createSlice({
    name: 'reOzsFormReducer',
    initialState: {
        isLoading: false,
        pageOzsForm: null,
        customer: null,
        ozsBuild: null,
        regions: null,
        cities: null,
        districts: null,
        reReferenceUnit: null,
        reBuildTypes: null,
        reObjectFunctionTypes: null,
        ozsFormById: null,
        ozsFormAdd: null,
        deleted: false,
        error: null,
        saveOzsFormEditResponse: null,
        changed: null,
        isDeleting: false,
        isAdding: false,
        ozsYears: null
    },
    reducers: {
        setLoading: (state) => {
            state.isLoading = true
            state.changed = null
        },
        setError: (state, action) => {
            state.isLoading = false
            state.error = action.payload
        },
        getPageOzsFormSuccess: (state, action) => {
            state.isLoading = false
            state.pageOzsForm = action.payload
        },
        getCustomerSuccess: (state, action) => {
            state.isLoading = false
            state.customer = action.payload
        },
        getOzsBuildSuccess: (state, action) => {
            state.isLoading = false
            state.ozsBuild = action.payload
        },
        getRegionsSuccess: (state, action) => {
            state.isLoadingSmetas = false
            state.regions = action.payload
        },
        getCitiesSuccess: (state, action) => {
            state.isLoading = false
            state.cities = action.payload
        },
        getDistrictsSuccess: (state, action) => {
            state.isLoading = false
            state.districts = action.payload
        },
        getReReferenceUnitSuccess: (state, action) => {
            state.isLoading = false
            state.reReferenceUnit = action.payload
        },
        getReBuildTypesSuccess: (state, action) => {
            state.isLoading = false
            state.reBuildTypes = action.payload
        },
        getReObjectFunctionTypesSuccess: (state, action) => {
            state.isLoading = false
            state.reObjectFunctionTypes = action.payload
        },
        getOzsFormByIdSuccess: (state, action) => {
            state.isLoading = false
            state.ozsFormById = action.payload
        },
        deleteOzsFormByIdSuccess: (state, action) => {
            state.isDeleting = false
            state.deleted = action.payload
        },
        // clearDelete: (state) => {
        //     state.isLoading = false
        //     state.deleted = false
        // },
        saveOzsFormEditSuccess: (state, action) => {
            state.isLoading = false
            state.changed = action.payload ? "Данные успешно изменены!" : null
            state.saveOzsFormEditResponse = action.payload
        },
        saveOzsFormAddSuccess: (state, action) => {
            state.isAdding = false
            state.ozsFormAdd = action.payload
        },
        getOzsYearsSuccess: (state, action) => {
            state.isLoading = false
            state.ozsYears = action.payload
        },
        clearAll: (state) => {
            state.ozsFormAdd = null
            state.saveOzsFormEditResponse = null
            state.deleted = null
            state.ozsFormById = null
            state.changed = null
        }
    }
})

export default reOzsFormReducer.reducer